import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=5f7a01e3&scoped=true"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"
import style0 from "./addGroup.vue?vue&type=style&index=0&id=5f7a01e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a01e3",
  null
  
)

export default component.exports